window.CheckoutOrderStorage = {
  key: 'pepx_pending_order',

  save(cart, attributes) {
    const createdAt = Date.now();
    const orderRef = `NL-${createdAt.toString(36).toUpperCase()}`;

    const snapshot = {
      orderRef,
      createdAt,
      subtotal: cart.items_subtotal_price || 0,
      total: cart.total_price || 0,
      currency: cart.currency || 'USD',
      attributes: attributes || {},
      items: (cart.items || []).map((item) => ({
        product_id: item.product_id,
        variant_id: item.variant_id,
        product_title: item.product_title,
        title: item.title,
        variant_title: item.variant_title,
        quantity: item.quantity,
        price: item.price,
        final_price: item.final_price,
        line_price: item.line_price,
        image: item.image
      }))
    };

    sessionStorage.setItem(this.key, JSON.stringify(snapshot));
    return snapshot;
  }
};
